import React from "react";
import { SearchResultPlan } from "../../@types";
import { useTranslate, shouldSuppressPlanBenefits } from "../../helpers";

interface CopaysProps {
  plan: SearchResultPlan;
}

const Copays: React.FunctionComponent<CopaysProps> = ({ plan }) => {
  const t = useTranslate();

  return (
    <div className="PlanCard__section" data-testid="copays">
      <h3 className="PlanCard__section_heading">{t("plan_terms.copays")}</h3>
      <div>
        <div className="PlanCard__info_group">
          <span>{t("plan_terms.primary")}: </span>
          <span className="PlanCard__semi_bold">
            {shouldSuppressPlanBenefits(plan)
              ? t("suppressed_plan_benefit")
              : plan.primary_doctor_visit_cost}
          </span>
        </div>
        <div className="PlanCard__info_group">
          <span>{t("plan_terms.specialist")}: </span>
          <span className="PlanCard__semi_bold">
            {shouldSuppressPlanBenefits(plan)
              ? t("suppressed_plan_benefit")
              : plan.specialist_doctor_visit_cost}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Copays;
